module.exports = __webpack_public_path__ + "static/img/honor2.ae039ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/honor2.png
// module id = nQNp
// module chunks = 1